import { memo } from "react";
import type { ProductClass, TradeDirection } from "@atlas-int/data/types";
import type { UIView } from "@atlas-int/data";
import { useIsolatedTooltipPayload, type TooltipDatum } from "@atlas-int/viz/shared";
import { TooltipContent } from "../components/tooltip/TooltipContent";

export interface TreemapTooltipContentProps {
  view: UIView;
  totalValue: number | undefined;
  tradeDirection: TradeDirection;
  productClass: ProductClass;
  loading: boolean;
  hasError: boolean;
  hasNoData: boolean;
  hasVizContent: boolean;
}

const TreemapTooltipContent = memo(function TreemapTooltipContent({
  view,
  totalValue,
  tradeDirection,
  productClass,
  loading,
  hasError,
  hasNoData,
  hasVizContent,
}: TreemapTooltipContentProps) {
  const tooltipState = useIsolatedTooltipPayload();
  if (
    !tooltipState?.contentData ||
    loading ||
    hasNoData ||
    hasError ||
    !hasVizContent
  ) {
    return null;
  }
  return (
    <TooltipContent
      datum={tooltipState.contentData as TooltipDatum}
      view={view}
      totalValue={totalValue}
      tradeDirection={tradeDirection}
      productClass={productClass}
      ref={null}
      fillColor={tooltipState.fillColor}
    />
  );
});

export default TreemapTooltipContent;
